import React from 'react';
import { Button, Card, CardHeader } from '@opendate-app/setlist';

const REPORTS = [
  { key: 'marketing_email', title: 'Email', description: 'Overview of your email marketing performance.', path: 'marketing-email' },
  { key: 'marketing_sms', title: 'SMS', description: 'Overview of your SMS marketing performance.', path: 'marketing-sms' },
  { key: 'marketing_web', title: 'Web', description: 'Overview of your web impressions and page views.', path: 'marketing-web' },
  { key: 'marketing_event_health', title: 'Event Health', description: 'Ticket sales velocity and financial health across your events.', path: 'marketing/event-health' },
  { key: 'marketing_show_tracker', title: 'Show Tracker', description: 'All confirmed shows with announce, presale, and onsale timing.', path: 'marketing/show-tracker' },
  { key: 'marketing_promo_codes', title: 'Promo Codes', description: 'Promo code performance across your venues.', path: 'marketing/promo-codes' },
  { key: 'marketing_meta_ads', title: 'Meta Ads', description: 'Spend, conversions, and pacing across your matched events.', path: 'marketing/meta-ads' },
  { key: 'marketing_demographics', title: 'Demographics', description: 'Age, gender, and location of your ticket buyers.', path: 'marketing/demographics' },
  {
    key: 'marketing_attribution',
    title: 'Attribution',
    description: 'Which channels, sources and partners drove your sales.',
    path: 'marketing/attribution',
    enabled: (team) => !!team?.package?.attribution,
  },
];

export const marketingReports = (team) => REPORTS.filter((report) => !report.enabled || report.enabled(team));

function MarketingReportCards({ team, isMobile }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(240px, 1fr))',
        gap: 16,
        marginBottom: 24,
      }}
    >
      {marketingReports(team).map((report) => (
        <Card key={report.key} header={<CardHeader title={report.title} supportingText={report.description} />}>
          <Button as="a" variant="link-color" size="sm" href={`/teams/${team.id}/reporting/${report.path}`}>
            {`Open ${report.title}`}
          </Button>
        </Card>
      ))}
    </div>
  );
}

export default MarketingReportCards;
